module.exports = __webpack_public_path__ + "dd1ee64298c45586d0916bc4ae64cdaf.png";